import React from 'react';
import '../styles/BureauMember.css';

const EnvelopeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="social-svg">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
    <polyline points="22,6 12,13 2,6"></polyline>
  </svg>
);

const LinkedinIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="social-svg">
    <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path>
    <rect x="2" y="9" width="4" height="12"></rect>
    <circle cx="4" cy="4" r="2"></circle>
  </svg>
);

const BureauMember = ({ member }) => {
  const handleImageError = (e) => {
    const fallbackImages = {
      'Président': 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop&crop=face',
      'Secrétaire Général': 'https://images.unsplash.com/photo-1494790108755-2616c667c671?w=400&h=400&fit=crop&crop=face',
      'Trésorier': 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop&crop=face'
    };
    e.target.src = fallbackImages[member.role] || fallbackImages['Président'];
  };

  return (
    <div className="member-card">
      <div className="member-card-header"></div>
      
      <div className="member-image-container">
        <img 
          src={member.image} 
          alt={member.name}
          className="member-image"
          onError={handleImageError}
        />
        <div className="member-overlay">
          <div className="member-social">
            {member.email && (
              <a href={`mailto:${member.email}`} className="social-icon" title="Email">
                <i className="icon-email"><EnvelopeIcon /></i>
              </a>
            )}
            {member.linkedin && (
              <a href={member.linkedin} className="social-icon" title="LinkedIn" target="_blank" rel="noopener noreferrer">
                <i className="icon-linkedin"><LinkedinIcon /></i>
              </a>
            )}
          </div>
        </div>
      </div>
      
      <div className="member-info">
        <div className="member-role-badge">{member.role}</div>
        <h3 className="member-name">{member.name}</h3>
        <p className="member-description">{member.description}</p>
      </div>
      
      <div className="member-decoration">
        <div className="decoration-line"></div>
      </div>
    </div>
  );
};

export default BureauMember;